import Isotope from "isotope-layout";
import jQueryBridget from "jquery-bridget";

jQueryBridget("isotope", Isotope, $);

export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
    onLoad() {
        /*const $schoolImage = $(".card .image");
        if ($schoolImage.length > 0) {
            $schoolImage.height($schoolImage.width());

            $(window).resize(function () {
                $schoolImage.height($schoolImage.width());
            });
        }*/

        const $taxonomy = $(".taxonomy-container");
        if ($taxonomy.length > 0) {

            $taxonomy.imagesLoaded().progress(function () {
                $taxonomy.isotope({
                    itemSelector: ".taxonomy-item",
                    percentPosition: true,
                    masonry: {
                        columnWidth: ".taxonomy-sizer",
                    },
                });
            });
        }

        const $filter = $(".filter");
        const $btnFilter = $(".page-header-bottom .filter .btn");
        const $filterReset = $(".filter-reset");

        if ($filter.length > 0) {
            $btnFilter.on("click", function () {
                $(".filter-content").toggleClass("open");
            });
        }

        if ($filter.length > 0) {
            $filterReset.on("click", function () {
                $taxonomy.isotope({filter: "*"});
                $(".filter-value").removeClass("active");
                $(".filter-reset").addClass("disabled");
                $btnFilter.removeClass("active");
            });

            $(".filter-value").each(function () {
                $(this).on("click", function () {
                    $btnFilter.addClass("active");
                    $taxonomy.isotope({filter: "."+ $(this).data("value")});
                    $(".filter-value").removeClass("active");
                    $(".filter-reset").removeClass("disabled");
                    $(this).addClass("active");
                });
            });
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/taxonomyData.js